/* 🤖 this file was generated by svg-to-ts */
export const iconPetChart: {
  name: 'pet_chart';
  data: string;
} = {
  name: 'pet_chart',
  data: `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16"><g fill="none" fill-rule="evenodd" stroke="#767676"><path d="m2.09 13.668 5.146-5.145 6.432-6.433"/><circle cx="2.09" cy="13.91" r="1.59" fill="#FFF"/><circle cx="8" cy="8" r="1.59" fill="#FFF"/><circle cx="13.91" cy="2.09" r="1.59" fill="#FFF"/></g></svg>`,
};
